import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, unref as _unref, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-787794b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "paper-row" }
const _hoisted_2 = { class: "align-left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Grasp(s):", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, " Object(s): ", -1))
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 0 }

import { ref } from 'vue'
import MicroRow from '@/components/Table/MicroRow.vue'
import store from '@/store'


export default {
  __name: 'PaperRow',
  props: {
    paper: Object
  },
  setup(__props) {



const displayMMList = ref(false)

function getSmallAuthors (authors) {
  const author = authors.split(',')[0]
  return `${author} et al.`
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("span", {
      class: "microgesture-name",
      onClick: _cache[0] || (_cache[0] = $event => (displayMMList.value = !displayMMList.value))
    }, [
      (!displayMMList.value)
        ? (_openBlock(), _createBlock(_component_unicon, {
            key: 0,
            name: "angle-down"
          }))
        : (_openBlock(), _createBlock(_component_unicon, {
            key: 1,
            name: "angle-right"
          }))
    ]),
    _createElementVNode("span", null, _toDisplayString(__props.paper.date), 1),
    _createElementVNode("span", null, _toDisplayString(__props.paper.title), 1),
    _createElementVNode("span", null, _toDisplayString(getSmallAuthors(__props.paper.authors)), 1),
    _createElementVNode("span", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("span", null, [
        (__props.paper.mmList[0].grasp && __props.paper.mmList[0].grasp.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(__props.paper.mmList[0].grasp.map(x => x[0].toUpperCase() + x.slice(1)).join(', ')), 1)
            ], 64))
          : (__props.paper.mmList[0].customGrasp && __props.paper.mmList[0].customGrasp.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(__props.paper.mmList[0].customGrasp), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" Free-Hand ")
              ], 64))
      ]),
      (__props.paper.mmList[0].grasp && __props.paper.mmList[0].grasp.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("span", null, [
              (__props.paper.mmList[0].object)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(__props.paper.mmList[0].object.replaceAll(',', ', ')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" No specific object ")
                  ], 64))
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("span", null, [
      _createElementVNode("a", {
        href: `https://doi.org/${__props.paper.doi}`,
        target: "_blank"
      }, [
        _createVNode(_component_unicon, {
          name: "external-link-alt",
          width: "18",
          height: "18"
        })
      ], 8, _hoisted_6),
      (_unref(store).isLogged && __props.paper.privateUrl)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            target: "_blank",
            class: "private-link",
            href: __props.paper.privateUrl
          }, [
            _createVNode(_component_unicon, {
              name: "external-link-alt",
              width: "18",
              height: "18"
            })
          ], 8, _hoisted_7))
        : _createCommentVNode("", true)
    ]),
    (displayMMList.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.paper.mmList.entries(), ([i, m]) => {
            return (_openBlock(), _createBlock(MicroRow, {
              paper: __props.paper,
              microgesture: {paper: __props.paper, ...m},
              key: `${i}-${__props.paper.citationKey}`,
              options: {noSecondRow: true}
            }, null, 8, ["paper", "microgesture"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}